<template>
  <v-container fluid>
    <material-card v-if="tblData.length" icon="mdi-clipboard-text" inline title="Fee Concession List">
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
        <router-link :to="{ name: 'addFeeConcession' }" :class="{ 'd-flex justify-start': $vuetify.breakpoint.xs }">
          <v-btn elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </router-link>
      </v-card-text>

      <v-divider class=" my-0 " />
      <v-data-table
      disable-pagination
        :hide-default-footer="true"
        :headers="headers"
        :items="tblData"
        :search.sync="search"
      >
        <template v-slot:item.amountOrPercentage="{ item }"> {{ item.amountOrPercentage }} {{ item.isPercentage ? '%' : null }}
          <v-icon small v-if="!item.isPercentage">mdi-currency-inr</v-icon>
        </template>

        <template v-slot:item.actions="{ item }">
          <router-link :to="{ name: 'editFeeConcession', params: { concessionId: item.id } }">
            <v-btn class="px-2 ml-1 white--text ma-1" color="success" min-width="0" small>
              <v-icon small> mdi-pencil</v-icon>
            </v-btn>
          </router-link>
          <v-btn @click="deleteItem(item.id,deleted=true)" v-if="item.isActive" class="px-2 ml-1 white--text ma-1" color="error" min-width="0" small>
            <v-icon small> mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="deleteItem(item.id,deleted=false)" v-else class="px-2 ml-1 white--text ma-1" color="info" min-width="0" small>
            <v-icon small> mdi-restore</v-icon>
          </v-btn>
        </template>
      </v-data-table>
           <v-col >
          <v-row>
            <v-col cols="4" sm="3">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per Page"
                @change="handlePageSizeChange"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="10"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
      </v-col>
    </material-card>
    <material-card v-if="!tblData.length" icon="mdi-clipboard-text" inline title="Fee Concession List">
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
      <router-link :to="{ name: 'addFeeConcession' }" class="ml-auto" :class="{ 'd-flex justify-start': $vuetify.breakpoint.xs }">
          <v-btn elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </router-link>
      </v-card-text>

      <v-divider class=" my-0 " />
      <v-data-table :headers="headers">
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
         <v-col >
          <v-row>
            <v-col cols="4" sm="3">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per Page"
                @change="handlePageSizeChange"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="10"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
      </v-col>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import { mapGetters } from 'vuex'
export default {
  components: { MaterialCard },
  data () {
    return {
      isLoading: false,
      deleted: false,
      search: '',
      tblData: [],
      academicYearID: '',
      franchiseeID: '',
      total: 0,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      headers: [
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Amount/Percentage', value: 'amountOrPercentage', align: 'center' },
        { text: 'Franchisee', value: 'franchisee.companyName', sortable: false },
        { text: 'Academic Year', value: 'franchiseeAcademicYear.academicYear' },
        { text: 'Fee Type', value: 'feeType.name' },
        { text: 'Action', value: 'actions' }
      ]
    }
  },
  async created () {
    if (this.franchiseeID) {
      this.getConcessionList()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
    if (this.academicYear.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    deleteItem: async function (id) {
      try {
        this.isLoading = true
        await http.get(`${CONSTANTS.API_URL}/api/fee-concession/student/status/${id}`)
        this.okMsg(this.deleted ? 'Successfully deleted!' : 'Successfully Restored')
        await this.getConcessionList()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getConcessionList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/fee-concession/student?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}&offset=${this.page - 1}&limit=${this.pageSize}`)
        this.tblData = res.data.rows
        this.totalPages = res.data ? Math.ceil(res.data.count / this.pageSize) : 0
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      this.searchFilterArray = []
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      if (this.franchiseeID) {
        await this.getConcessionList()
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getConcessionList()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getConcessionList()
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>

<style></style>
